import { render, staticRenderFns } from "./cardItemByCollection.vue?vue&type=template&id=9e2469d2&"
import script from "./cardItemByCollection.vue?vue&type=script&lang=js&"
export * from "./cardItemByCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/card/cardItemByCollection.vue"
export default component.exports